import React from 'react';
import { Button } from 'antd';
import { useCropperModalActions } from '../../../../features/cropperModal';

const ErrorFooter = () => {
  const { onCancel } = useCropperModalActions();

  return (
    <>
      <Button
        type="primary"
        onClick={onCancel}
      >
        Закрыть
      </Button>
    </>
  );
};

export default ErrorFooter;
